// components/public/Navbar.jsx
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getRestauranteActual } from '../../api/public';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [logo, setLogo] = useState(null);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const cargarLogo = async () => {
      try {
        const restaurante = await getRestauranteActual();

        if (restaurante?.logo) {
          const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
          const logoUrl = `${API_URL}${restaurante.logo}?t=${Date.now()}`;
          setLogo(logoUrl);
        }
      } catch (error) {
        console.error('Error cargando logo en Navbar:', error);
      }
    };

    cargarLogo();
  }, []);

  // Detectar scroll para ocultar/mostrar navbar
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      if (currentScrollY < 10) {
        setIsVisible(true);
      } else if (currentScrollY > lastScrollY) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);

  const menuItems = [
    { name: 'Inicio', path: '/' },
    { name: 'Menú', path: '/menu' },
    { name: 'Promociones', path: '/promociones' },
    { name: 'Restaurantes', path: '/restaurantes' },
    { name: 'Contacto', path: '/contacto' },
  ];

  return (
    <nav className={`bg-white shadow-md fixed top-0 left-0 right-0 z-50 transition-transform duration-300 ${
      isVisible ? 'translate-y-0' : '-translate-y-full'
    }`}>
      <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-4">
        <div className="flex justify-between items-center min-h-16 py-1">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            {logo && <img src={logo} alt="Logo" className="h-16 w-auto" />}
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="text-gray-700 hover:text-red-600 font-medium transition-colors duration-200"
              >
                {item.name}
              </Link>
            ))}
            
            {/* Botón de Login */}
            <button
              onClick={() => navigate('/login')}
              className="bg-red-600 text-white px-6 py-2 rounded-full hover:bg-red-700 transition-all duration-200 font-semibold shadow-md hover:shadow-lg"
            >
              Iniciar Sesión
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-gray-700 hover:text-red-600 focus:outline-none"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden pb-4">
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="block py-2 text-gray-700 hover:text-red-600 hover:bg-gray-50 px-4 rounded transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                {item.name}
              </Link>
            ))}
            <button
              onClick={() => {
                navigate('/login');
                setIsMenuOpen(false);
              }}
              className="w-full mt-4 bg-red-600 text-white px-6 py-2 rounded-full hover:bg-red-700 transition-all font-semibold"
            >
              Iniciar Sesión
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
